import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { TelescopeIcon } from 'src/components/icons/telescope'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 ${Shapes.spacing[4]}px;
  gap: 40px;
  overflow: hidden;
`

const Content = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: ${Colors.neutral50};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Shapes.spacing[2]}px;
  min-height: 200px;
  padding: ${Shapes.spacing[4]}px 20%;
  text-align: center;
  border-radius: ${Shapes.borderRadius}px;
`
type WidgetCardEmptyProps = {
  title?: string
  message: string
  style?: React.CSSProperties
}
export const WidgetCardEmpty = (props: WidgetCardEmptyProps) => {
  const { message, style, title = 'No Data to Show' } = props
  return (
    <Wrapper style={style}>
      <Content>
        <TelescopeIcon size={48} color="rgba(133, 153, 174, 1)" />
        <Typography variant="header3" color={Colors.neutral700} align="center">
          {title}
        </Typography>
        <Typography variant="textmdm" color={Colors.neutral400} align="center">
          {message}
        </Typography>
      </Content>
    </Wrapper>
  )
}
